import { CAMPUS_GUIDE_LOAD } from './actions';

const defaultState = {
  school: {}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case CAMPUS_GUIDE_LOAD:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
